module.exports = __webpack_public_path__ + "media/images/common/order_ov-9f449538838e32681a3f19eff45d4b38.png";